import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { userTier } from '../../../../../apollo/cache';
import StyledTable from '../../../../shared/components/StyledTable';
import { ColumnsProvider } from '../providers/columnsProvider';

/**
 * @typedef {object} LicensesTableProps
 * @property {Array<*>} [usersData]
 * @property {number} [orgId]
 * @property {string} [orgName]
 * @property {boolean} [singleUnit]
 * @property {boolean} [loading]
 * @property {number} pageMode
 */

/**
 * @param {LicensesTableProps} props
 */
const LicensesTable = props => {
  const { usersData = [], singleUnit = false, orgId, orgName, loading = false, pageMode } = props;
  const currentUserTier = useReactiveVar(userTier);

  const filteredColumns = ColumnsProvider.getFilteredColumns(
    usersData,
    singleUnit,
    currentUserTier,
    pageMode,
    orgId,
    orgName
  );

  return (
    <div className='table-of-licenses'>
      <StyledTable
        columns={filteredColumns}
        dataSource={usersData}
        pagination={false}
        showSorterTooltip={false}
        loading={loading}
      />
    </div>
  );
};

export default LicensesTable;
